import {
  FOREX_TRADING_REQUEST_DESER,
  ForexTradingRequest,
} from "../../tastyworks/forex-trading-request"
import type HttpClient from "../../tastyworks/http"
import type { SingleResponse } from "../../tastyworks/response"

export class ForexTradingService {
  constructor(private readonly customerMeClient: HttpClient) {}

  readonly show = async (): Promise<SingleResponse<ForexTradingRequest>> =>
    this.customerMeClient.show(
      new ForexTradingRequest(),
      FOREX_TRADING_REQUEST_DESER.update,
      "forex-trading-requests"
    )
}
